import React, { useState, useEffect, useMemo } from 'react';

import { Col, Row } from 'react-bootstrap';

import { useRMDispatch, useRMSelector } from 'redux/hooks';
import {
  isNullOrUndefined,
  showAlertSnackBar,
  sortAlphanumericDescending,
} from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import MarcoService from 'business/services/MarcoService';
import {
  BooleanPropertyDTO,
  DisputedScoresIds,
  MarcoPlateInfoDto,
  MarcoScoreInfo,
} from 'business/models/Models';
import { RMModal, LoadingModal } from 'components/modal';
import RMCustomModal from 'components/customComponents/Controls/RMCustomModal';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import RecomendedScoreRadioButtons from './DisputedScoreModal/RecomendedScoreRadioButtons/RecomendedScoreRadioButtons';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { IStyle } from 'Styles';
import { toggleScoringWell } from 'redux/reducers/experimentDataReducer';
import { DropDetails } from 'components/well/constants';
import { ScoresOfWellDrops } from 'components/Experiment/constants';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import SideBarComponent from '../SideBarComponent/SideBarComponent';
import AutoScores from '../AutoScore/AutoScores';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { useAllWellNavigationDetails } from 'redux/hooks/experiment';
import useRMLite from 'CustomHooks/useRMLite';
import './MarcoScore.scss';
import { FmlxBanner, FmlxLink, FmlxSwitch, FmlxTooltip } from 'fmlx-common-ui';
import { setHideAutoScores } from 'redux/reducers/headerReducer';
import { selectHideAutoScores } from 'redux/selectors/StateSelectors';
import { useIgnoreAutoScoreWellDrop } from 'CustomHooks/useIgnoreAutoScoreWellDrop';
import {
  getIgnoreAutoScoreButtonText,
  getIgnoreAutoScoreInfoMessage,
  IGNORE_AUTO_SCORE_MESSAGES,
} from 'constants/messages/ignoreAutoScore';
import { EXTERNAL_LINKS } from 'constants/externalLinks';
import { RMLink } from 'components/customComponents/RMLink';
interface DisputeModalBodyProps {
  scoreGroups: Array<any>;
  disputedScoreGroupId: DisputedScoresIds[];
  setDisputedScoreGroupId: any;
  setSelectedScoreGroupsCountForDispute: any;
  setDisputeReason: any;
  setRecommendedScore: any;
  selectedScore: string;
}
function DisputeModalBody({
  scoreGroups,
  setSelectedScoreGroupsCountForDispute,
  disputedScoreGroupId,
  setDisputedScoreGroupId,
  setDisputeReason,
  setRecommendedScore,
  selectedScore,
}: DisputeModalBodyProps) {
  const recomendedScoresList = [
    { value: '0', text: 'Clear' },
    { value: '1', text: 'Bad Precipitate' },
    { value: '2', text: 'Good Precipitate' },
    { value: '3', text: 'Interesting' },
    { value: '4', text: 'Crystal' },
  ];

  function AddScoreToDisputed(imageBatchWellDropScoreID: number, dropToScoreID: number) {
    const disputedScores = disputedScoreGroupId;
    const index = disputedScores
      .map((item) => {
        return item.imageBatchWellDropScoreID;
      })
      .indexOf(imageBatchWellDropScoreID);
    if (index == -1) {
      const disputedScoreIds: DisputedScoresIds = new DisputedScoresIds();
      disputedScoreIds.imageBatchWellDropScoreID = imageBatchWellDropScoreID;
      disputedScoreIds.dropToScoreID = dropToScoreID;
      disputedScores.push(disputedScoreIds);
    } else {
      disputedScores.splice(index, 1);
    }
    setSelectedScoreGroupsCountForDispute(disputedScores.length);
    setDisputedScoreGroupId(disputedScores);
  }

  function recommendedScoreHandleOptionChange(optionValue) {
    setRecommendedScore(optionValue);
  }

  return (
    <div
      id="commandpanel-marcoscore-disputemodalbody-container"
      className="container"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Row
        id="commandpanel-marcoscore-disputemodal-text-confirm"
        style={{ paddingBottom: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-confirm-message"
            className="modal-text"
          >
            Are you sure want to dispute MARCO Score of this drop?
          </div>
        </Col>
      </Row>

      <Row id="commandpanel-marcoscore-disputemodal-text-selectgroup">
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-selectgroup-message"
            className="modal-text"
          >
            Please select which score group got it wrong.
          </div>
        </Col>
      </Row>
      {scoreGroups.map((item, i) => (
        <div
          id={`commandpanel-marcoscore-disputemodal-scoregroup-${item.imageBatchWellDropScoreID}`}
          key={`-score-group-${i}`}
          style={styles.disputeModalRow}
        >
          <RMCheckBoxY
            isChecked={disputedScoreGroupId
              .map((ids) => {
                return ids.imageBatchWellDropScoreID;
              })
              .includes(item.imageBatchWellDropScoreID)}
            onChange={() => {
              AddScoreToDisputed(item.imageBatchWellDropScoreID, item.dropToScoreID);
            }}
          />
          <div
            id={`commandpanel-marcoscore-disputemodal-scoregroup-text-${item.imageBatchWellDropScoreID}`}
            style={styles.scoreGroupTextContainer}
            className="d-flex flex-row"
          >
            <div
              id={`commandpanel-marcoscore-disputemodal-scoregroup-text-${item.scoreGroupName}`}
              style={styles.scoreGroupName}
            >
              {item.scoreGroupName + ': '}
            </div>
            <div
              id={`commandpanel-marcoscore-disputemodal-scorename-text-${item.scoreName}`}
              style={styles.scoreName}
            >
              {item.scoreName}
            </div>
          </div>
        </div>
      ))}

      <Row
        id="commandpanel-marcoscore-disputemodal-text-correctscore"
        style={{ paddingTop: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-correctscore-message"
            className="modal-text"
          >
            What is the correct score?
          </div>
        </Col>
      </Row>

      <Row
        id="commandpanel-marcoscore-disputemodal-correctscore-options"
        style={{
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          marginLeft: '3%',
        }}
      >
        {recomendedScoresList.map((item, i) => (
          <RecomendedScoreRadioButtons
            key={`recommended-score-${i}`}
            recommendedScoreValue={item.value}
            recommendedScoreText={item.text}
            selectedScore={selectedScore}
            radioButtonSize={'20'}
            onChange={recommendedScoreHandleOptionChange}
          ></RecomendedScoreRadioButtons>
        ))}
      </Row>

      <Row
        id="commandpanel-marcoscore-disputemodal-comments-label"
        style={{ paddingTop: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-comments-label-message"
            className="modal-text"
          >
            Comments
          </div>
        </Col>
      </Row>

      <textarea
        id="commandpanel-marcoscore-disputemodal-comments-input"
        onChange={(e) => {
          setDisputeReason(e.target.value);
        }}
        rows={4}
        className="dispute-reason-text-area"
        style={{ width: '100%', marginBottom: '1.5vh' }}
        name="disputeReason"
      ></textarea>
    </div>
  );
}

const defaultMarcoScoreInfo = [[]];

interface Props {
  wellDetails?: DropDetails;
  handleOnMarkDisputedScore: (disputedScoresIds: DisputedScoresIds[]) => void;
  imageBatchId?: number;
  dropNumber?: number;
  selectedWellsScores?: ScoresOfWellDrops[][];
}
function MarcoScore(props: Props) {
  const {
    wellDetails: wellDetailsProp,
    handleOnMarkDisputedScore,
    imageBatchId,
    dropNumber,
    selectedWellsScores,
  } = props;
  enum EModalType {
    AlertDialog = 0,
    DisputeDialog = 1,
  }

  const [showLoading, setShowLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMarcoTrainingAlert, setshowMarcoTrainingAlert] = useState(false);
  const [modalType, setModalType] = useState(0);
  const [scoresGroup, setScoresGroup] = useState([]);
  const [alertType, setAlertType] = useState(EAlertType.INFO);
  const [alertTitle, setAlertTitle] = useState('ROCK MAKER');
  const [alertMessage, setAlertMessage] = useState('');
  const [isMarcoScoringEnabled, setIsMarcoScoringEnabled] = useState(true);
  const [isAutoScoreAllowed, setIsAutoScoreAllowed] = useState(true);
  const hideAutoScores = useRMSelector(selectHideAutoScores);

  const _imageBatchId = wellDetailsProp ? wellDetailsProp?.imageBatchId : imageBatchId;
  const _dropNumber = wellDetailsProp ? wellDetailsProp?.dropNumber : dropNumber;

  const wellNavigationDetails = useAllWellNavigationDetails();
  const lastSelectedWell = wellNavigationDetails?.[wellNavigationDetails?.length - 1];
  const isMultipleWellsSelected = !wellDetailsProp && wellNavigationDetails?.length > 1;
  const wellNum = wellDetailsProp ? wellDetailsProp.wellNum : lastSelectedWell?.wellNum;
  const plateId = wellDetailsProp ? wellDetailsProp.plateID : lastSelectedWell?.plateID;

  const [marcoScoreInfo, setMarcoScoreInfo] = useState([]);
  const [selectedScoreGroupsCountForDispute, setSelectedScoreGroupsCountForDispute] =
    useState(0);

  const [disputedScoreGroupId, setDisputedScoreGroupId] = useState<DisputedScoresIds[]>(
    [],
  );
  const dispatch = useRMDispatch();
  const rmLite = useRMLite();
  const [recommendedScore, setRecommendedScore] = useState('0');
  const [disputeReason, setDisputeReason] = useState('');

  function setDefaultMarcoScoreInfo() {
    setMarcoScoreInfo(defaultMarcoScoreInfo);
  }

  function hideMarcoModal() {
    setShowModal(false);
  }

  async function fetchMarcoScoreInfo(plateID, imageBatchId, wellNumber, dropNumber) {
    if (
      !isNullOrUndefined(imageBatchId) &&
      !isNullOrUndefined(dropNumber) &&
      !isNullOrUndefined(plateID) &&
      !isNullOrUndefined(wellNumber) &&
      isAutoScoreAllowed
    ) {
      // getMarcoScoreInfo
      const marcoService = new MarcoService();
      const marcoScoreInfo: MarcoScoreInfo[] = await marcoService.getMarcoScoreInfo(
        plateID,
        imageBatchId,
        wellNumber,
        dropNumber,
      );
      if (isNullOrUndefined(marcoScoreInfo) || marcoScoreInfo.length == 0) {
        setDefaultMarcoScoreInfo();
      } else {
        const sortedScoreInfo = sortAlphanumericDescending(marcoScoreInfo, 'model');
        setMarcoScoreInfo(sortedScoreInfo);
      }
    } else {
      setDefaultMarcoScoreInfo();
    }
  }

  async function fetchIsAutoScoredAllowed(plateID?: number) {
    if (isNullOrUndefined(plateId)) {
      setIsAutoScoreAllowed(false);
    } else {
      const marcoService = new MarcoService();
      const marcoPlateInfo: MarcoPlateInfoDto = await marcoService.isAutoScoredAllowed(
        plateID,
      );

      setIsAutoScoreAllowed(marcoPlateInfo?.isValidType ?? true);
    }
  }

  async function getNonDisputedScores() {
    setShowModal(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    const nonDisputedScores = await marcoService.GetNonDisputedScores(
      plateId,
      _imageBatchId,
      wellNum,
      _dropNumber,
    );
    setShowLoading(false);
    if (isNullOrUndefined(nonDisputedScores) || nonDisputedScores.length == 0) {
      setModalType(EModalType.AlertDialog);
      setShowModal(true);
      setAlertType(EAlertType.INFO);
      setAlertTitle('Dispute Auto Score');
      setAlertMessage('Auto score is already marked disputed.');
    } else {
      setShowModal(false);
      setAlertTitle('Dispute Auto Score');
      setModalType(EModalType.DisputeDialog);
      setShowModal(true);
      setScoresGroup(nonDisputedScores);
    }
  }

  async function sendScoresDispute(
    disputedScoresIds,
    recommendedScore: number,
    disputeReason: string,
  ) {
    setShowModal(false);

    setShowLoading(true);

    const marcoService = new MarcoService();
    const sendScoresDisputeResponse = await marcoService.SendDisputedScore(
      disputedScoresIds,
      recommendedScore,
      disputeReason,
    );
    setShowLoading(false);
    if (!isNullOrUndefined(sendScoresDisputeResponse)) {
      if (sendScoresDisputeResponse == true) {
        handleOnMarkDisputedScore(disputedScoreGroupId);

        dispatch(toggleScoringWell());

        showAlertSnackBar(
          EAlertType.SUCCESS,
          ESnackBarPosition.TOP,
          'Dispute Score has been sent successfully',
        );
      } else {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'No score found for dispute',
        );
      }
    }
  }

  const getMarcoAutoScoreEnabledStatus = async () => {
    const globalPreferencesService = new GlobalPreferencesService();
    const property = (await globalPreferencesService.getProperty(
      'Scores.MARCOAutoScoring.Enabled',
    )) as BooleanPropertyDTO;
    setIsMarcoScoringEnabled(property.value);
  };

  useEffect(() => {
    getMarcoAutoScoreEnabledStatus();
  }, []);

  async function setMarcoTrainingAndImprovementStatus(
    collectRetrainingImages,
    autoCollectRetrainingImages,
  ) {
    setshowMarcoTrainingAlert(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    await marcoService.SetMarcoTrainingAndImprovementStatus(
      collectRetrainingImages,
      autoCollectRetrainingImages,
    );

    setShowLoading(false);
  }
  useEffect(() => {
    if (showModal == true && modalType == EModalType.DisputeDialog) {
      setDisputedScoreGroupId([]);
      setSelectedScoreGroupsCountForDispute(0);
      setRecommendedScore('0');
      setDisputeReason('');
    }
  }, [showModal]);
  useEffect(() => {
    fetchMarcoScoreInfo(plateId, _imageBatchId, wellNum, _dropNumber);
  }, [plateId, _imageBatchId, wellNum, _dropNumber]);

  useEffect(() => {
    // Autoscore will not work on LCP and Microfluidic plate
    fetchIsAutoScoredAllowed(plateId);
  }, [plateId]);

  async function sendToMarco(overwriteFlag = false) {
    setShowModal(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    const sendToMarcoResponse = await marcoService.SendToMarco(
      plateId,
      _imageBatchId,
      _dropNumber,
      overwriteFlag,
    );
    setShowLoading(false);
    if (!isNullOrUndefined(sendToMarcoResponse)) {
      setModalType(EModalType.AlertDialog);
      setShowModal(true);
      setAlertType(sendToMarcoResponse.alertType);
      setAlertTitle(sendToMarcoResponse.alertTitle);
      setAlertMessage(sendToMarcoResponse.alertMessage);
    }
  }

  const ignoreAutoScoreParams = useMemo(() => {
    if (
      isNullOrUndefined(plateId) ||
      isNullOrUndefined(_imageBatchId) ||
      isNullOrUndefined(wellNum) ||
      isNullOrUndefined(_dropNumber)
    ) {
      return null;
    }

    return {
      plateId,
      imageBatchId: _imageBatchId,
      wellNumber: wellNum,
      dropNumber: _dropNumber,
      dropId: wellDetailsProp?.dropId,
    };
  }, [plateId, _imageBatchId, wellNum, _dropNumber, wellDetailsProp?.dropId]);

  const {
    isAutoScoreIgnored: isSelectedWellAutoScoreIgnored,
    showIgnoreAutoScoreConfirmation,
  } = useIgnoreAutoScoreWellDrop({
    scores: selectedWellsScores,
    params: ignoreAutoScoreParams,
    isDisabled:
      isMultipleWellsSelected ||
      isNullOrUndefined(plateId) ||
      isNullOrUndefined(_imageBatchId) ||
      isNullOrUndefined(wellNum) ||
      isNullOrUndefined(_dropNumber),
    refreshExperimentScores: !wellDetailsProp?.dropId,
    onToggleStart: () => setShowLoading(true),
    onToggleEnd: () => setShowLoading(false),
  });

  const marcoToolsButtons = [
    {
      id: 'ignoreautoscore',
      isHidden: rmLite,
      label: IGNORE_AUTO_SCORE_MESSAGES.label,
      infoMessage: getIgnoreAutoScoreInfoMessage(isSelectedWellAutoScoreIgnored),
      buttonText: getIgnoreAutoScoreButtonText(isSelectedWellAutoScoreIgnored),
      icon: (
        <RMSvgIcon
          id="marcoscore-toolbuttons-ignoreautoscore-icon"
          name={isSelectedWellAutoScoreIgnored ? 'EyeOpen' : 'EyeClosed'}
          width={16}
          height={16}
          fill="#ffffff"
        />
      ),
      onClick: async () => {
        showIgnoreAutoScoreConfirmation();
      },
      isDisabled:
        isMultipleWellsSelected ||
        isNullOrUndefined(plateId) ||
        isNullOrUndefined(_imageBatchId) ||
        isNullOrUndefined(wellNum) ||
        isNullOrUndefined(_dropNumber),
    },
    {
      id: 'disputescore',
      label: 'Dispute Score',
      infoMessage:
        'Did you disagree on our result? Send the selected images to let us know',
      buttonText: 'DISPUTE',
      icon: (
        <RMSvgIcon
          id="marcoscore-toolbuttons-disputescore-icon"
          name="DisputeScoreIcon"
          width={16}
          height={16}
          fill="#ffffff"
        />
      ),
      onClick: async () => {
        await getNonDisputedScores();
      },
      isDisabled:
        rmLite ||
        isNullOrUndefined(plateId) ||
        isNullOrUndefined(_imageBatchId) ||
        isNullOrUndefined(wellNum),
    },
    {
      id: 'sendinspection',
      label: 'Auto Scoring',
      infoMessage: (
        <div className="flex flex-col gap-y-1">
          <span>Send this inspection to your local server for Autoscoring.</span>
          <span className="inline-flex flex-wrap items-center gap-x-1">
            Learn more about
            <RMLink
              id="commandpanel-exppanel-marcoscore-sendinspection-scoremodels-link"
              text="score models"
              url={EXTERNAL_LINKS.AUTOSCORE_WEBHELP}
              customLinkSize={FmlxLink.Size.SMALL}
              customIconSize={12}
              customColor="#f7a246"
            />
          </span>
        </div>
      ),
      buttonText: 'SCORE INSPECTION',
      onClick: async () => {
        await sendToMarco();
      },

      isDisabled:
        isNullOrUndefined(plateId) ||
        isNullOrUndefined(_imageBatchId) ||
        isNullOrUndefined(_dropNumber) ||
        !isMarcoScoringEnabled,
    },
  ];

  function toggleHideAutoScores() {
    dispatch(setHideAutoScores(!hideAutoScores));
  }
  function renderMarcoToolButton(button) {
    return (
      <div
        id={`commandpanel-exppanel-marcoscore-${button.id}-row`}
        key={button.id}
        className="flex h-10 w-full items-center justify-between bg-[#FAFAFA] px-2"
      >
        <div className="flex min-w-0 items-center gap-x-2">
          <span className="text-sm font-semibold leading-5 text-[#111111]">
            {button.label}
          </span>
          <FmlxTooltip
            id={`commandpanel-exppanel-marcoscore-${button.id}-info-tooltip`}
            title={button.infoMessage}
            placement={FmlxTooltip.Placement.TOP_START}
          >
            <span className="inline-flex cursor-pointer items-center text-[#d2872d] [&_svg_path]:fill-[#d2872d]">
              <RMSvgIcon
                id={`commandpanel-exppanel-marcoscore-${button.id}-info`}
                name="Info"
                width={14}
                height={14}
                noFill
              />
            </span>
          </FmlxTooltip>
        </div>
        <RMCustomButton
          key={`${button.id}-${button.buttonText}`}
          id={`commandpanel-exppanel-marcoscore-${button.id}-button`}
          Icon={button.icon}
          title={button.buttonText}
          isDisabled={button.isDisabled}
          onClick={button.onClick}
          buttonMainContainerStyle={{ opacity: button.isDisabled ? 0.5 : 1 }}
          contentContainerClass="!inline-flex !h-6 !min-w-20 !items-center !justify-center !gap-1 !rounded !border-0 !bg-[#313131] !px-2 !text-white"
          iconClass="[&_svg]:shrink-0 [&_svg_path]:fill-white [&_svg_rect]:fill-transparent"
          titleClass="!text-xs !font-semibold !uppercase !leading-none !text-white"
        />
      </div>
    );
  }

  return (
    <div
      id="commandpanel-exppanel-marcoscore-wrapper"
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <LoadingModal showModal={showLoading} text={'Please Wait'} />
      {isAutoScoreAllowed && (
        <>
          <RMCustomModal
            showModal={showMarcoTrainingAlert}
            setShowModal={setshowMarcoTrainingAlert}
            heading={alertTitle}
            buttonsList={[
              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-yes',
                onClick: () => {
                  setMarcoTrainingAndImprovementStatus(true, true);
                },
                buttonText: 'Yes',
              },

              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-no',
                onClick: () => {
                  setMarcoTrainingAndImprovementStatus(true, false);
                },
                buttonText: 'No',
              },

              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-cancel',
                onClick: () => {
                  setshowMarcoTrainingAlert(false);
                },
                buttonText: 'Cancel',
              },
            ]}
            body={
              modalType == EModalType.AlertDialog ? (
                <p
                  id="commandpanel-exppanel-marcoscore-trainingalert-message"
                  style={{ whiteSpace: 'break-spaces' }}
                >
                  {alertMessage}
                </p>
              ) : (
                <DisputeModalBody
                  scoreGroups={scoresGroup}
                  setSelectedScoreGroupsCountForDispute={
                    setSelectedScoreGroupsCountForDispute
                  }
                  setRecommendedScore={setRecommendedScore}
                  setDisputeReason={setDisputeReason}
                  selectedScore={recommendedScore}
                  disputedScoreGroupId={disputedScoreGroupId}
                  setDisputedScoreGroupId={setDisputedScoreGroupId}
                ></DisputeModalBody>
              )
            }
          ></RMCustomModal>
          <RMModal
            id="commandpanel-exppanel-marcoscore-warningmodal"
            showModal={showModal}
            setShowModal={setShowModal}
            heading={alertTitle}
            isOkOnly={
              modalType == EModalType.DisputeDialog || alertType == EAlertType.WARNING
                ? false
                : true
            }
            okayDisabled={
              modalType == EModalType.DisputeDialog &&
              selectedScoreGroupsCountForDispute == 0
            }
            okButtonText="Ok"
            noButtonText="Cancel"
            onOk={
              modalType == EModalType.DisputeDialog
                ? async () => {
                    sendScoresDispute(
                      disputedScoreGroupId,
                      parseInt(recommendedScore),
                      disputeReason,
                    );
                  }
                : alertType == EAlertType.WARNING
                ? async () => {
                    await sendToMarco(true);
                  }
                : modalType == EModalType.AlertDialog
                ? hideMarcoModal
                : () => {
                    setShowModal(false);
                  }
            }
            body={
              modalType == EModalType.AlertDialog ? (
                <p
                  id="commandpanel-exppanel-marcoscore-warningmodal-message"
                  style={{ whiteSpace: 'break-spaces' }}
                >
                  {alertMessage}
                </p>
              ) : (
                <DisputeModalBody
                  scoreGroups={scoresGroup}
                  setSelectedScoreGroupsCountForDispute={
                    setSelectedScoreGroupsCountForDispute
                  }
                  setRecommendedScore={setRecommendedScore}
                  setDisputeReason={setDisputeReason}
                  selectedScore={recommendedScore}
                  disputedScoreGroupId={disputedScoreGroupId}
                  setDisputedScoreGroupId={setDisputedScoreGroupId}
                ></DisputeModalBody>
              )
            }
          ></RMModal>

          <div
            id="commandpanel-exppanel-marcoscore-scoreslist"
            className="h-[58vh] overflow-y-auto"
          >
            <div className="flex flex-col px-[10px] gap-x-1 mb-2">
              <div className="font-semibold">Score Options</div>
              <div className="ml-2">
                <div className="flex flex-row items-center">
                  <div className="w-[30%] text-sm">Hide Auto Scores</div>
                  <FmlxSwitch
                    id={'auto-select-next-well'}
                    size="sm"
                    checked={hideAutoScores}
                    onChange={toggleHideAutoScores}
                  />
                </div>
              </div>
            </div>

            {marcoScoreInfo.map((scoreInfo, index) => (
              <SideBarComponent
                key={`marco-score-key-${index}`}
                heading={scoreInfo.model ? `${scoreInfo.model}` : 'Well not scored'} // Pass the model to heading
                subHeading={
                  scoreInfo.fasaScore
                    ? `Composite Score: ${(scoreInfo.fasaScore * 100).toFixed(2)}%`
                    : ''
                }
                subHeadingStyle={{
                  marginLeft: 'auto',
                  textAlign: 'right',
                  paddingRight: '2%',
                }}
                isCollapsible={scoreInfo.model ? true : false}
                handleColapse={() => {}}
                isCollapsedFirstTime={true}
                ContainerComponent={
                  <AutoScores
                    scoreDetails={scoreInfo.scoreDetails}
                    morphologyDetails={scoreInfo.morphologyDetails}
                    ultravioletDetails={scoreInfo.ultravioletDetails}
                  />
                }
              />
            ))}
          </div>

          <div
            id="commandpanel-exppanel-marcoscore-buttonsrow"
            className="flex w-full flex-col gap-y-2 px-1 mt-1"
          >
            {marcoToolsButtons
              .filter((button) => !button.isHidden)
              .map(renderMarcoToolButton)}
          </div>
          <div
            id="commandpanel-exppanel-marcoscore-footer"
            className="flex flex-row items-center justify-start"
          ></div>
        </>
      )}

      {!isAutoScoreAllowed && (
        <FmlxBanner
          id="commandpanel-exppanel-marcoscore-autoscore-unavailable"
          title={`Currently the Autoscore isn't available for LCP and Microfluids plate type.`}
          hideCloseButton={true}
        />
      )}
    </div>
  );
}

const styles: IStyle = {
  disputeModalRow: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    marginLeft: '1%',
  },
  scoreGroupTextContainer: {
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
  },
  scoreGroupName: {
    marginLeft: 3,
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
  scoreName: {
    fontStyle: 'italic',
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
};
export default React.memo(MarcoScore);
